import CloseIcon from '@mui/icons-material/Close';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { FC } from 'react';
import { MRT_RowData, MRT_TableInstance } from 'material-react-table';
import { useTranslation } from 'react-i18next';
import { ButtonProps } from '@mui/material';
import UtmsButton from '@shared/components/ui/UtmsButton';

interface ToggleMoreFiltersButtonProps extends ButtonProps {
    table: MRT_TableInstance<MRT_RowData>;
    hasFilters?: boolean;
}

const ToggleMoreFiltersButton: FC<ToggleMoreFiltersButtonProps> = ({ table, hasFilters, ...props }) => {
    const { t } = useTranslation();
    const toggleTableColumnFilters = () => {
        table && table.setShowColumnFilters(!table.options.state.showColumnFilters);
    };

    return (
        <UtmsButton
            startIcon={table.options.state.showColumnFilters ? <CloseIcon /> : <FilterAltIcon />}
            onClick={toggleTableColumnFilters}
            {...props}
        >
            {table.options.state.showColumnFilters
                ? hasFilters
                    ? t('clear_filters')
                    : t('close_filters')
                : t('more_filters')}
        </UtmsButton>
    );
};

export default ToggleMoreFiltersButton;
